import { render } from "./BasePostItem.vue?vue&type=template&id=1737c087"
import script from "./BasePostItem.vue?vue&type=script&lang=js"
export * from "./BasePostItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__